export default "__VITE_ASSET__nHRWmu_b__"